import { render } from "./item_description.vue?vue&type=template&id=3c76dbd0"
import script from "./item_description.vue?vue&type=script&lang=js"
export * from "./item_description.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__